import {
    FaYoutube,
    FaBandcamp,
    FaShoppingCart, 
    FaSpotify,
    FaAngleDown,
    FaAngleRight, 
    FaMusic, 
    FaTshirt,
    FaFacebookSquare,
    FaInstagramSquare,
    FaDeezer,
    FaTwitter,
    FaTiktok
} from "react-icons/fa";
import {AiOutlineInfoCircle} from "react-icons/ai";
import {ImEvil} from "react-icons/im";
import {MdKeyboardArrowUp} from "react-icons/md";

//ICONS TO LISTEN OR BUY MUSIC AND MERCH
export const youTube = <FaYoutube/> 
export const bandCamp = <FaBandcamp/> 
export const seasonShop = <FaShoppingCart/>
export const spotify = <FaSpotify/>
export const deezer = <FaDeezer/>
//ICON TO DISPLAY OR HIDE INFORMATIONS
export const moreDetails = <AiOutlineInfoCircle/>
export const hideDescription = <FaAngleDown/>
export const showDescription = <FaAngleRight/>
//ICONS TO ADD MEANING BESIDE CHECKBOXES
export const music = <FaMusic/>
export const merch = <FaTshirt/>
//ICON TO MAKE NEWS TITLE MORE VISIBLE
export const evil = <ImEvil/>
//SOCIAL NETWORK ICONS
export const facebook = <FaFacebookSquare/>
export const instagram = <FaInstagramSquare/>
export const twitter = <FaTwitter/>
export const tiktok = <FaTiktok/>
//ARROW UP
export const arrowUp = <MdKeyboardArrowUp/>

